import { Button } from '@components/button';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@components/dialog';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { BenchUser } from '@root/globalTypes';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useDelete } from '@services/staff/benchUsers/delete';
import { TrashIcon } from 'lucide-react';

export function DeleteBenchUserDialog({ benchUser }: { benchUser: BenchUser }) {
  const { t } = useTranslation('app');
  const { verifyUserPermission } = useCheckUserPermissions();
  const [open, setOpen] = useState(false);

  const onSuccess = async () => {
    setOpen(false);
    toast.success(t('toast.benchUsers.deleteSuccess'));
  };

  const { mutate, isPending } = useDelete({
    id: benchUser.id,
    callback: onSuccess,
  });

  if (!verifyUserPermission('bench_users_delete')) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm" className="w-14">
          <TrashIcon className="h-5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle className="flex items-center gap-2 whitespace-nowrap">
          {t('pages.benchUser.remove.title')}
        </DialogTitle>
        <p>{t('pages.benchUser.remove.info')}</p>
        <Button disabled={isPending} onClick={() => mutate()} variant="destructive">
          {t('actions.delete')}
        </Button>
        <Button disabled={isPending} onClick={() => setOpen(false)} variant="ghost">
          {t('actions.cancel')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
